export const fantasyArticleListData = `
aResults {
  sMatchPreview
  ePlatformType
  _id
  sTitle
  sSubtitle
  sSrtTitle
  oSeo {
    sSlug
  }
  sMatchPreview
  oImg {
    sUrl
    sText
    sCaption
    sAttribute
  }
  dPublishDate
  dModifiedDate
  dPublishDisplayDate
  oCategory {
    sName
    _id
    eType
    oSeo {
      sSlug
    }
  }
  ePlatformType
  nDuration
  oTImg {
    sUrl
    sText
    sCaption
    sAttribute
  }
}
`
